module.exports = __webpack_public_path__ + "img/aanleg2.5bf02e78.jpg";